import { WarehouseService } from "./../../../services/catalogs/WarehouseService";
import React from "react";
import { WarehouseDetail } from "../../../components/Pages/Catalogs/Warehouse/WarehouseDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateWarehouseDto } from "../../../dtos/catalogs/warehouse/CreateWarehouseDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupWarehouse } from "../../../components/Shared/NewForms/NFLookupWarehouse";
import WarehouseList from "../../../components/Pages/Catalogs/Warehouse/WarehouseList";

export const Warehouse: IAppEntity = {
  entityType: "catalog",
  title: "Warehouse",
  pluralTitle: "Warehouses",
  apiUrl: "warehouses",
  apiEnum: ReferenceTypes.CatalogWarehouse,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(WarehouseDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(WarehouseList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupWarehouse, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new WarehouseService(this.apiUrl);
  },
  getEmptyModel(): CreateWarehouseDto {
    return {
      name: "",
      description: "",
      divisionId: "",
      companyId: "",
      actualAddress: "",
      createdDate: new Date(),
      phoneNumber: "",
    };
  },
};
